import { axiosGetTheme, axiosSetTheme } from '../../api/admin/default';
var use_theme = parent.websiteTheme.theme_color;
window.siteStyle = '';
window.JsonStyleSetting = '';
window.JsonStyleSite = '';
window.JsonStyleSection = '';

(function ($) {
    RVwys.plugin['SiteTheme'] = true;
    RVwys.SiteTheme = {};

    $(document).bind('editorReady', function () {
        $('.wsFont').ready(function () {
            RVwys.SiteTheme.ListFont();
        });

        var frameBody = $('#frameBody').get(0);
        var frameBodyDoc = frameBody.contentWindow || frameBody.contentDocument;
        if (frameBodyDoc.document) frameBodyDoc = frameBodyDoc.document;
        var frameBodyContent = $(frameBodyDoc).contents();
        var TagHeaderiFrame = $(frameBodyDoc).contents().find('head');
        var fb = $('#frameBody').get(0).contentWindow;

        JsonStyleSite = CSSJSON.toJSONliteral(parent.websiteTheme.theme_site);
        JsonStyleSection = CSSJSON.toJSONliteral(
            parent.websiteTheme.theme_section
        );

        RVwys.SiteTheme.appendLinkCss(TagHeaderiFrame);
        RVwys.SiteTheme.appendCssBody(TagHeaderiFrame);

        if (
            !fb.$('#app-layout .uk-container').first().hasClass('rv-block-full')
        ) {
            $('.fullwidthSection').addClass('uk-hidden');
        }

        parent.$('.btn-save-siteTheme').click(function () {
            var css = frameBodyContent.find('#theme_website').text();

            var fullwidth = $('.rowfull').prop('checked')
                ? 'rv-block-full'
                : 'rv-block-full0';

            var data = {
                fullwidth: fullwidth,
                theme_color: use_theme,
                theme_css: css,
            };

            axiosSetTheme(data).then(response => {
                console.pop[response.data.status]({
                    text: 'Save Success',
                    delay: 5000,
                });
            });
        });

        parent.$('.btn-reset-siteTheme').click(function () {
            siteStyle.html(parent.websiteTheme.theme_css);
            parent.JsonStyleSetting = CSSJSON.toJSONliteral(
                parent.websiteTheme.theme_css
            );
            RVwys.SiteTheme.SetActive();
        });

        parent.$('.website-theme .rv-theme').click(function () {
            var oColor = $(this)
                .attr('class')
                .match(/rv-theme-(\w*)/)[1];
            var oThemeColor = 'theme-' + oColor;
            use_theme = oThemeColor;

            axiosGetTheme(oThemeColor).then(response => {
                var json = CSSJSON.toJSONliteral(response.data.theme_css);
                var css = CSSJSON.toCSS(json);

                $(frameBodyDoc).contents().find('#theme_website').html(css);
                parent.JsonStyleSetting = json;
                RVwys.SiteTheme.SetActive();
            });
        });

        $('.gdTheme').spectrum({
            showAlpha: true,
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'rgb',
            beforeShow: function () {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);
                parent.$(document).bind('click.spectrum', function () {
                    $(this).spectrum('revert');
                });
            },
            move: function (color) {
                color = color.toRgbString();
                $(this).attr('gdcolor', color);

                RVwys.SiteTheme.gdGenarate();
            },
            hide: function (color) {
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
            },
        });

        $('.wsSetcolor').spectrum({
            preferredFormat: 'hex',
            showAlpha: true,
            showInput: true,
            allowEmpty: true,
            beforeShow: function () {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                    'z-index': '0',
                });
                parent.$('body').prepend(overlaypanel);
                var key = $(this).attr('cmd');

                if (key == 'wsCustomBG') {
                    var CssCheck =
                        parent.JsonStyleSetting['children']['body'][
                            'attributes'
                        ];

                    if (CssCheck.hasOwnProperty('background')) {
                        delete parent.JsonStyleSetting['children']['body'][
                            'attributes'
                        ]['background'];
                    }

                    if (CssCheck.hasOwnProperty('filter')) {
                        delete parent.JsonStyleSetting['children']['body'][
                            'attributes'
                        ]['filter'];
                        delete parent.JsonStyleSetting['children']['body'][
                            'attributes'
                        ]['background'];
                    }

                    if (CssCheck.hasOwnProperty('background-image')) {
                        delete parent.JsonStyleSetting['children']['body'][
                            'attributes'
                        ]['background-image'];
                        parent
                            .$('.wys-WebsiteBodyDesign')
                            .find('.section-bg')
                            .removeAttr('style');
                    }
                }

                $(RVwys.currentiFrame).bind('keydown', RVwys.unkeydown);
            },
            move: function (color) {
                var key = $(this).attr('cmd');

                var keyClass = RVwys.SiteTheme[key]['class'];
                var keyCss = RVwys.SiteTheme[key]['css'];
                var ThemeColor = color;

                if (key == 'wsCustomBG') {
                    ThemeColor = color + ' !important';
                }

                parent.JsonStyleSetting['children'][keyClass]['attributes'][
                    keyCss
                ] = ThemeColor;

                var css = CSSJSON.toCSS(parent.JsonStyleSetting);
                siteStyle.html(RVwys.SiteTheme.ImportFont(css));
            },

            hide: function (color) {
                var key = $(this).attr('cmd');
                var keyClass = RVwys.SiteTheme[key]['class'];
                var keyCss = RVwys.SiteTheme[key]['css'];
                var ThemeColor = color;

                if (key == 'wsCustomBG') {
                    ThemeColor = color + ' !important';
                }

                parent.JsonStyleSetting['children'][keyClass]['attributes'][
                    keyCss
                ] = ThemeColor;
                var css = CSSJSON.toCSS(parent.JsonStyleSetting);
                siteStyle.html(RVwys.SiteTheme.ImportFont(css));
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
                $(RVwys.currentiFrame).unbind('keydown', RVwys.unkeydown);
            },
        });

        $('.wsFontSize').change(function () {
            var key = $(this).attr('cmd');

            var keyClass = RVwys.SiteTheme[key]['class'];
            var keyCss = RVwys.SiteTheme[key]['css'];
            parent.JsonStyleSetting['children'][keyClass]['attributes'][
                keyCss
            ] = this.value;
            var css = CSSJSON.toCSS(parent.JsonStyleSetting);
            siteStyle.html(RVwys.SiteTheme.ImportFont(css));
        });

        $('.rowfull').change(function (e) {
            var fb = $('#frameBody').get(0).contentWindow;
            var oDiv = fb.$('.bodyTemplate').parent();
            console.log(oDiv);
            if (this.checked) {
                oDiv.removeClass('rv-block-full0').addClass('rv-block-full');
                $('.panelColorSite').removeClass('enable').addClass('disabled');
                $('.fullwidthSection').removeClass('uk-hidden');
            } else {
                oDiv.removeClass('rv-block-full').addClass('rv-block-full0');
                $('.panelColorSite').removeClass('disabled').addClass('enable');
                $('.fullwidthSection').addClass('uk-hidden');
            }
        });

        $('.wys-WebsiteBodyDesign #bgFixed').change(function () {
            this.checked
                ? (parent.JsonStyleSetting['children']['body']['attributes'][
                      'background-attachment'
                  ] = 'fixed')
                : delete parent.JsonStyleSetting['children']['body'][
                      'attributes'
                  ]['background-attachment'];

            var css = CSSJSON.toCSS(parent.JsonStyleSetting);
            parent.siteStyle.html(RVwys.SiteTheme.ImportFont(css));
        });

        $('.wsBackground .rv-theme').click(function () {
            //use background-color
            var KeyClass = $(this)
                .attr('class')
                .match(/rv-theme-(\w*)/)[0];
            var CssClass =
                JsonStyleSite['children']['.' + KeyClass]['attributes'][
                    'background-color'
                ];

            var CssCheck =
                parent.JsonStyleSetting['children']['body']['attributes'];

            if (CssCheck.hasOwnProperty('background')) {
                delete parent.JsonStyleSetting['children']['body'][
                    'attributes'
                ]['background'];
                $('.gdTheme').spectrum('set', '');
            }

            if (CssCheck.hasOwnProperty('filter')) {
                delete parent.JsonStyleSetting['children']['body'][
                    'attributes'
                ]['filter'];
                delete parent.JsonStyleSetting['children']['body'][
                    'attributes'
                ]['background'];
            }

            if (CssCheck.hasOwnProperty('background-image')) {
                delete parent.JsonStyleSetting['children']['body'][
                    'attributes'
                ]['background-image'];
                parent
                    .$('.wys-WebsiteBodyDesign')
                    .find('.section-bg')
                    .removeAttr('style');
            }

            $('.wsCustomBG').spectrum('set', RVwys.SiteReplaceCSS(CssClass));
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-image'
            ] = 'none';
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-color'
            ] = CssClass;
            var css = CSSJSON.toCSS(parent.JsonStyleSetting);
            siteStyle.html(RVwys.SiteTheme.ImportFont(css));

            parent.$('#imageLib').hide();
            parent.isSiteBG = false;
        });

        $('.wsGradient .rv-theme').click(function () {
            //use background
            var KeyClass = $(this)
                .attr('class')
                .match(/rv-theme-(\w*)/)[0];
            var CssClass =
                JsonStyleSite['children']['.' + KeyClass]['attributes'][
                    'background'
                ];

            var CssCheck =
                parent.JsonStyleSetting['children']['body']['attributes'];

            if (CssCheck.hasOwnProperty('background-color')) {
                delete parent.JsonStyleSetting['children']['body'][
                    'attributes'
                ]['background-color'];
                $('.wsCustomBG').spectrum('set', 'transparent');
                $('.wsCustomBG')
                    .next()
                    .find('.sp-preview-inner')
                    .addClass('sp-clear-display');
            }

            if (CssCheck.hasOwnProperty('filter')) {
                delete parent.JsonStyleSetting['children']['body'][
                    'attributes'
                ]['filter'];
                delete parent.JsonStyleSetting['children']['body'][
                    'attributes'
                ]['background'];
            }

            if (CssCheck.hasOwnProperty('background-image')) {
                delete parent.JsonStyleSetting['children']['body'][
                    'attributes'
                ]['background-image'];
                parent
                    .$('.wys-WebsiteBodyDesign')
                    .find('.section-bg')
                    .removeAttr('style');
            }

            parent.JsonStyleSetting['children']['body']['attributes'][
                'background'
            ] = CssClass;
            var css = CSSJSON.toCSS(parent.JsonStyleSetting);
            siteStyle.html(RVwys.SiteTheme.ImportFont(css));

            parent.$('#imageLib').hide();
            parent.isSiteBG = false;
        });

        $('.site-gradient span').click(function () {
            var KeyClass = $(this).attr('class');
            var CssClass =
                JsonStyleSite['children']['.site-gradient .' + KeyClass][
                    'attributes'
                ];

            RVwys.SiteTheme.gdSetColor(CssClass);
        });

        $('.positon-site').change(function () {
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-position'
            ] = $(this).find(':selected').attr('value');

            var css = CSSJSON.toCSS(parent.JsonStyleSetting);
            siteStyle.html(RVwys.SiteTheme.ImportFont(css));
        });

        $('.wsFontBody').change(function () {
            var isFont = $(this).val();
            try {
                parent.JsonStyleSetting['children'][
                    'h1,h2,h3,h4, body, div#selected_body, .rvsb_design_block, .uk-navbar-nav > li > a, div#selected_body a, #footerTemplate, #footerTemplate a'
                ]['attributes']['font-family'] = `'${isFont}'`;
            } catch (e) {
                parent.JsonStyleSetting['children'][
                    'h1,h2,h3,h4,body,div#selected_body,.rvsb_design_block,.uk-navbar-nav>li>a,div#selected_body a,#footerTemplate,#footerTemplate a'
                ]['attributes']['font-family'] = `'${isFont}'`;
            }
            var css = CSSJSON.toCSS(parent.JsonStyleSetting);
            siteStyle.html(RVwys.SiteTheme.ImportFont(css));
        });

        $('.wsFontHeading').change(function () {
            var isFont = $(this).val();
            parent.JsonStyleSetting['children']['h1,h2,h3']['attributes'][
                'font-family'
            ] = `'${isFont}'`;
            var css = CSSJSON.toCSS(parent.JsonStyleSetting);
            siteStyle.html(RVwys.SiteTheme.ImportFont(css));
        });
    });
    RVwys.SiteTheme.loadWebsiteBodyDesign = function () {
        parent.siteStyle = $('#theme_website');

        RVwys.SiteTheme.SetActive();
        RVwys.SiteTheme.wsJsonSet();

        if (!$('.bodyTemplate').parent().hasClass('rv-block-full')) {
            parent.$('.rowfull').prop('checked', false).trigger('change');
        }

        var image =
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-image'
            ];
        parent
            .$('.wys-WebsiteBodyDesign')
            .find('.section-bg')
            .css({ background: image + ' no-repeat 50% / contain' });
    };

    RVwys.SiteTheme.appendLinkCss = function (TagHeaderiFrame) {
        if (parent.wex.wysiwygMixManifest) {
            var ScssJson = [
                'color-section-background',
                'color-site-background',
            ];
            var parseWysiwygMixManifest = parent.wex.wysiwygMixManifest;
            var pathVendor = RVwys.baseUrl.replace('rvwysiwyguikit', '');

            $.each(ScssJson, function (k, fileCss) {
                var path_editableuikit =
                    parent.wex.app_env != 'local'
                        ? parent.wex.cdn.cdnURL +
                          '/w' +
                          parseWysiwygMixManifest['/css/' + fileCss + '.css']
                        : pathVendor +
                          '/vendor/rvsitebuilder/wysiwyg' +
                          parseWysiwygMixManifest['/css/' + fileCss + '.css'];

                var editorCssfile = $(
                    '<link rel="stylesheet" id="' +
                        fileCss +
                        '" href="' +
                        path_editableuikit +
                        '" />'
                );

                $('body').append(editorCssfile);
                //			 TagHeaderiFrame.append(editorCssfile);
            });
        }
    };

    RVwys.SiteTheme.appendCssBody = function (TagHeaderiFrame) {
        var json = CSSJSON.toJSONliteral(parent.websiteTheme.theme_css);
        var css = RVwys.SiteTheme.ImportFont(CSSJSON.toCSS(json));

        var styleSite = $(
            '<style type="text/css" id="theme_website"></style>'
        ).append(css);

        TagHeaderiFrame.append(styleSite);
        siteStyle = TagHeaderiFrame.find('#theme_website');
        var style = TagHeaderiFrame.find('#theme_website').text();
        parent.JsonStyleSetting = CSSJSON.toJSONliteral(style);

        parent
            .$('.rv-theme-background.rv-' + use_theme)
            .addClass('rv-theme-active');
        /*	 var Cssprase = CSSJSON.toCSS(json);*/
    };
    RVwys.SiteTheme.SetActive = function () {
        //console.log('SetActive');
        //console.log(parent.JsonStyleSetting);
        var sBG =
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-color'
            ];
        try {
            var sFontSize =
                parent.JsonStyleSetting['children'][
                    'body, div#selected_body, div#footerTemplate'
                ]['attributes']['font-size'];
        } catch (e) {
            var sFontSize =
                parent.JsonStyleSetting['children'][
                    'body,div#selected_body,div#footerTemplate'
                ]['attributes']['font-size'];
        }
        try {
            var sFontColor =
                parent.JsonStyleSetting['children']['body, div#selected_body'][
                    'attributes'
                ]['color'];
        } catch (e) {
            var sFontColor =
                parent.JsonStyleSetting['children']['body,div#selected_body'][
                    'attributes'
                ]['color'];
        }
        var sHeadColor =
            parent.JsonStyleSetting['children']['h1,h2,h3']['attributes'][
                'color'
            ];
        try {
            var sLinkColor =
                parent.JsonStyleSetting['children'][
                    'div#selected_body a, div#selected_body a:visited'
                ]['attributes']['color'];
        } catch (e) {
            var sLinkColor =
                parent.JsonStyleSetting['children'][
                    'div#selected_body a,div#selected_body a:visited'
                ]['attributes']['color'];
        }
        try {
            var sLinkHoverColor =
                parent.JsonStyleSetting['children'][
                    'div#selected_body a:hover, div#selected_body a:active'
                ]['attributes']['color'];
        } catch (e) {
            var sLinkHoverColor =
                parent.JsonStyleSetting['children'][
                    'div#selected_body a:hover,div#selected_body a:active'
                ]['attributes']['color'];
        }

        var sGradient =
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background'
            ];

        try {
            var sFontFace =
                parent.JsonStyleSetting['children'][
                    'h1,h2,h3,h4, body, div#selected_body, .rvsb_design_block, .uk-navbar-nav > li > a, div#selected_body a, #footerTemplate, #footerTemplate a'
                ]['attributes']['font-family'];
        } catch (e) {
            var sFontFace =
                parent.JsonStyleSetting['children'][
                    'h1,h2,h3,h4,body,div#selected_body,.rvsb_design_block,.uk-navbar-nav>li>a,div#selected_body a,#footerTemplate,#footerTemplate a'
                ]['attributes']['font-family'];
        }

        if (sFontFace) {
            sFontFace = sFontFace.replace(/'/g, '');
        }

        var sFontHead =
            parent.JsonStyleSetting['children']['h1,h2,h3']['attributes'][
                'font-family'
            ];
        if (sFontHead) {
            sFontHead = sFontHead.replace(/'/g, '');
        }

        parent.$('.wsHeadColor').spectrum('set', sHeadColor);
        parent.$('.wsFontColor').spectrum('set', sFontColor);
        parent.$('.wsFontLinkColor').spectrum('set', sLinkColor);
        parent.$('.wsFontLinkHoverColor').spectrum('set', sLinkHoverColor);
        parent.$('.wsCustomBG').spectrum('set', RVwys.SiteReplaceCSS(sBG));
        parent
            .$('.wsFontSize [value=' + sFontSize + ']')
            .prop('selected', true);
        parent
            .$('.wsFontBody [value="' + sFontFace + '"]')
            .prop('selected', true);
        parent
            .$('.wsFontHeading [value="' + sFontHead + '"]')
            .prop('selected', true);
        parent
            .$('#gdThemeLeft')
            .spectrum('set', RVwys.SiteMatchGD(sGradient)[0])
            .attr('gdcolor', RVwys.SiteMatchGD(sGradient)[0]);
        parent
            .$('#gdThemeRight')
            .spectrum('set', RVwys.SiteMatchGD(sGradient)[1])
            .attr('gdcolor', RVwys.SiteMatchGD(sGradient)[1]);
    };

    RVwys.SiteTheme.wsJsonSet = function () {
        parent.RVwys.SiteTheme['wsCustomBG'] = {
            class: 'body',
            css: 'background-color',
        };
        parent.RVwys.SiteTheme['wsHeadColor'] = {
            class: 'h1,h2,h3',
            css: 'color',
        };
        parent.RVwys.SiteTheme['wsFontColor'] = {
            class: 'body, div#selected_body',
            css: 'color',
        };
        parent.RVwys.SiteTheme['wsFontLinkColor'] = {
            class: 'div#selected_body a, div#selected_body a:visited',
            css: 'color',
        };
        parent.RVwys.SiteTheme['wsFontLinkHoverColor'] = {
            class: 'div#selected_body a:hover, div#selected_body a:active',
            css: 'color',
        };
        parent.RVwys.SiteTheme['wsFontSize'] = {
            class: 'body, div#selected_body, div#footerTemplate',
            css: 'font-size',
        };
    };

    RVwys.SiteTheme.gdCurrentColor = function (gdColor) {
        var regexPattenColor = /((rgba|rgb)\(([0-9\,\.\s]+)\))/gm;

        var bgLeft = gdColor.match(regexPattenColor)[0];
        var bgRight = gdColor.match(regexPattenColor)[1];

        $('#gdThemeLeft').spectrum('set', bgLeft);
        $('#gdThemeLeft').attr('gdColor', bgLeft);

        $('#gdThemeRight').spectrum('set', bgRight);
        $('#gdThemeRight').attr('gdColor', bgRight);
    };

    RVwys.SiteTheme.gdSetColor = function (CssClass) {
        //use filter,background
        var CssCheck =
            parent.JsonStyleSetting['children']['body']['attributes'];

        if (CssCheck.hasOwnProperty('background-color')) {
            delete parent.JsonStyleSetting['children']['body']['attributes'][
                'background-color'
            ];
            $('.wsCustomBG').spectrum('set', 'transparent');
            $('.wsCustomBG')
                .next()
                .find('.sp-preview-inner')
                .addClass('sp-clear-display');
        }

        if (CssCheck.hasOwnProperty('background')) {
            delete parent.JsonStyleSetting['children']['body']['attributes'][
                'background'
            ];
        }

        if (CssCheck.hasOwnProperty('background-image')) {
            delete parent.JsonStyleSetting['children']['body']['attributes'][
                'background-image'
            ];
            parent
                .$('.wys-WebsiteBodyDesign')
                .find('.section-bg')
                .removeAttr('style');
        }

        RVwys.SiteTheme.gdCurrentColor(CssClass['background'][0]);

        $.each(CssClass, function (key, css) {
            parent.JsonStyleSetting['children']['body']['attributes'][
                key
            ] = css;
        });

        var css = CSSJSON.toCSS(parent.JsonStyleSetting);
        siteStyle.html(RVwys.SiteTheme.ImportFont(css));

        parent.$('#imageLib').hide();
        parent.isSiteBG = false;
    };

    RVwys.SiteTheme.gdGenarate = function () {
        var gdLeft =
            $('#gdThemeLeft').attr('gdcolor') == undefined
                ? 'rgba(0, 0, 0, 0) 0%'
                : $('#gdThemeLeft').attr('gdcolor') + ' 0%';
        // var gdRight = $('#gdThemeRight').attr('gdcolor');
        var gdRight =
            $('#gdThemeRight').attr('gdcolor') == undefined
                ? 'rgba(0, 0, 0, 0) 100%'
                : $('#gdThemeRight').attr('gdcolor') + ' 100%';

        var CssColor = {
            background: [
                'linear-gradient(180deg, ' + gdLeft + ', ' + gdRight + ')',
                '-moz-linear-gradient(top, ' + gdLeft + ', ' + gdRight + ')',
                '-webkit-linear-gradient(top, ' + gdLeft + ', ' + gdRight + ')',
            ],
        };

        RVwys.SiteTheme.gdSetColor(CssColor);
    };

    RVwys.SiteReplaceCSS = function (str) {
        return str ? str.replace(/\!important/gim, '') : str;
    };

    RVwys.SiteMatchGD = function (str) {
        var regexPattenColor = /((rgba|rgb)\(([0-9\,\.\s]+)\))/gm;

        return str ? str[0].match(regexPattenColor) : '';
    };

    RVwys.imageSiteReChoose = function () {
        parent.isSiteBG = true;
        parent.isSectionBG = false;

        var rowFour = parent.$('.wys-WebsiteBodyDesign');
        var imageLib = parent.$('.imageLib');
        var posRowFour = rowFour.position();
        var posright = posRowFour.right - (imageLib.width() - 11);

        imageLib.show().css({
            left: posright,
            top: posRowFour.top,
        });

        if (parent.$('.imageBoxView-free').html() == '') {
            parent.$('#imageLib-tabs').tabs('option', 'active', 0);
        }
    };

    RVwys.SiteTheme.rowSiteBG = function (othis) {
        if (isTexture) {
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-image'
            ] = 'url(' + $(othis).attr('data') + ')';
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-size'
            ] = 'auto';
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-repeat'
            ] = 'repeat';
        } else {
            delete parent.JsonStyleSetting['children']['body']['attributes'][
                'background-repeat'
            ];
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-image'
            ] = 'url(' + $(othis).attr('data') + ')';
            parent.JsonStyleSetting['children']['body']['attributes'][
                'background-size'
            ] = 'cover';
        }

        var css = CSSJSON.toCSS(parent.JsonStyleSetting);
        parent.siteStyle.html(RVwys.SiteTheme.ImportFont(css));

        parent
            .$('.wys-WebsiteBodyDesign')
            .find('.section-bg')
            .css({
                background:
                    'url(' +
                    $(othis).attr('data') +
                    ') no-repeat 50% / contain',
            });
    };

    RVwys.SiteTheme.ListFont = function () {
        var strFont = '<option >Default</option>';

        try {
            if (wex.addFont != undefined) {
                $.each(parent.wex.addFont, function (k, v) {
                    strFont += `<option value="${v}" class="rvfont" style="font-family:'${v}'">${v}</option>`;
                });
            }

            //strFont += '<option class="box-line"></option>';
            if (parent.wex.aFont != undefined) {
                $.each(parent.wex.aFont, function (k, v) {
                    strFont += `<option value="${v}" style="font-family:'${v}'">${v}</option>`;
                });
            }
        } catch (error) {
            console.log(error);
        }
        $('.wsFont').html(strFont);
    };

    RVwys.SiteTheme.ImportFont = function (themeCss) {
        var findSpace = themeCss.match(/url.*;$/gim);
        if (findSpace) {
            $.each(findSpace, function (key, params) {
                themeCss = themeCss.replace(params, params.replace(/\s/g, ''));
            });
        }

        return themeCss;
    };
})(jQuery);
